import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { adminApi, errorMessage } from "../../lib/api";
import { inr } from "../landing/usePricing";

export const WalletsDialog = ({ open, onClose }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    adminApi.get("/admin/wallets").then((r) => setItems(r.data)).catch((e) => toast.error(errorMessage(e)));
  }, []);
  useEffect(() => { if (open) load(); }, [open, load]);

  const adjust = (a) => {
    const amount = Number(window.prompt(`Amount to add (use minus to deduct) for ${a.company_name}`));
    if (!amount) return;
    const note = window.prompt("Reason / note") || "Manual adjustment";
    adminApi.post(`/admin/wallets/${a.id}/adjust`, { amount, note }).then(() => { toast.success("Wallet updated"); load(); })
      .catch((e) => toast.error(errorMessage(e)));
  };
  const chargeNow = () => {
    if (!window.confirm("Charge this month's commission now for all active placements? Each placement is charged only once per month.")) return;
    adminApi.post("/admin/wallets/charge-commission").then((r) => { toast.success(`${r.data.placements_charged} placements charged for ${r.data.month}`); load(); })
      .catch((e) => toast.error(errorMessage(e)));
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="wallets-dialog" className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-none border-white/10 bg-[#0F172A] text-slate-100">
        <DialogHeader><DialogTitle className="font-heading text-xl">Employer wallets</DialogTitle></DialogHeader>
        <p className="text-xs text-amber-300">Test mode: recharges are simulated, no real money moves.</p>
        <button onClick={chargeNow} data-testid="wallets-charge-commission" className="self-start bg-orange-500 px-4 py-2 text-sm font-semibold text-white hover:bg-orange-600">Charge monthly commission now</button>
        {items.length === 0 && <p className="text-slate-500">No employer has logged in yet.</p>}
        {items.map((a) => (
          <div key={a.id} data-testid={`wallet-row-${a.phone}`} className="flex flex-wrap items-center justify-between gap-3 border-t border-white/5 py-3 text-sm">
            <span><span className="font-semibold text-white">{a.company_name}</span><br /><span className="font-mono text-slate-500">{a.phone}</span></span>
            <span className="text-slate-400">{a.active_placements} hired</span>
            <span className={`font-mono ${a.balance < 0 ? "text-red-300" : "text-white"}`}>{inr(a.balance)}</span>
            <button onClick={() => adjust(a)} data-testid={`wallet-adjust-${a.phone}`} className="border border-white/15 px-3 py-1.5 text-xs hover:border-orange-500">Adjust</button>
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};
